<template>
  <el-form
    :model="model"
    :inline="inline"
    :rules="rules"
    ref="model"
    :show-message="true"
    @keyup.enter.native="keyUpEnter"
    @validate="updateBtn"
    label-position="right"
    :label-width="labelWidth"
    class="demo-form-inline"
  >
    <slot></slot>
    <span style="margin-right: 30px" v-if="showButtonBox">
      <el-button
        type="primary"
        v-if="preservation"
        @click="submit()"
        :disabled="!canSubmit"
        :class="buttonClass ? 'button-size' : 'overWidth'"
      >
        {{ submitBtnText }}
      </el-button>
      <el-button class="button-size" @click="cancel()" v-if="showButton">
        取 消
      </el-button>
    </span>

    <slot class="butAfter" name="butAfter"></slot>
  </el-form>
</template>

<script>
import { submitMixin } from "mixin";
import { ergodicKeys } from "common/js/common-utils";
import SubmitText from "mixin/model/SubmitText";

export default {
  name: "CommonElForm",
  mixins: [submitMixin],
  props: {
    model: {
      type: Object,
      default: {},
    },
    rules: {
      type: Object,
      default: null,
    },
    submitBtnText: {
      type: String,
      default: "确定",
    },
    submitService: {
      type: Function,
      default: null,
    },
    submitData: {
      type: Object,
      default: null,
    },
    failTitle: {
      type: String,
      default: null,
    },
    loadingText: {
      type: String,
      default: null,
    },
    failText: {
      type: String,
      default: null,
    },
    successText: {
      type: String,
      default: null,
    },
    buttonClass: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showButtonBox: {
      type: Boolean,
      default: true,
    },
    preservation: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: "",
    },
    SubmitButton: {
      type: Boolean,
      default: false,
    },
    needBefore: {
      type: Boolean,
      default: false,
    },
    handleCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validMap: {},
      canSubmit: this.SubmitButton,
    };
  },
  mounted() {
    ergodicKeys(this.rules, (key) => {
      this.validMap[key] = !(typeof this.rules[key][0].required == "function"
        ? this.rules[key][0].required()
        : this.rules[key][0].required);
      // console.log(key, this.validMap[key])
    });
  },
  methods: {
    updateBtn(key, valid) {
      //   console.log(key, valid, this.validMap);
      if (this.validMap[key] == valid) {
        return;
      }
      this.validMap[key] = valid;

      let result = true;
      ergodicKeys(this.validMap, (key) => {
        // console.log(key, result, this.validMap[key], result && this.validMap[key])
        result = result && this.validMap[key];
        return !result;
      });

      if (this.handleCheck) {
        this.handleValid();
      }

      this.canSubmit = result;
      this.$emit("validField", {
        key,
        valid,
        canSubmit: result,
      });
    },
    handleValid() {
      let result = true;
      this.$refs["model"].validate((valid) => {
        if (valid) {
          result = true;
        } else {
          result = false;
        }
      });
      this.canSubmit = result;
    },
    submit: function () {
      if (this.needBefore) {
        this.$emit("beforeSubmit");
        return;
      }

      this.showLoading();
      const params = this.submitData == null ? this.model : this.submitData;
      ergodicKeys(params, (key) => {
        if (typeof params[key] == "string") {
          params[key] = params[key].trim();
        }
      });
      this.doValidAndSubmit(
        "model",
        this.submitService,
        params,
        (res) => {
          this.hideLoading();
          this.$emit("success", res);
        },
        new SubmitText({
          failTitle: this.failTitle,
          loadingText: this.loadingText,
          successText: this.successText,
          failText: this.failText,
        }),
        (error) => {
          this.hideLoading();
          this.$emit("fail", error);
        },
        this.handleCheck
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    validate(callback) {
      this.$refs["model"].validate((valid) => {
        callback && callback(valid);
      });
    },
    validateField(key, callback) {
      this.$refs.model.validateField(key, callback);
    },
    clearValidate(key, callback) {
      this.$refs.model.clearValidate(key, callback);
    },
    resetFields() {
      ergodicKeys(this.model, (key) => {
        this.model[key] = "";
      });
    },
    keyUpEnter() {
      this.$emit("keyUpEnter");
    },
  },
  watch: {
    rules() {
      ergodicKeys(this.rules, (key) => {
        this.validMap[key] = false;
      });
      this.canSubmit = false;
    },
  },
};
</script>

<style scoped>
.el-button.isLight {
  background-color: #fff;
  border-color: #fff;
  color: #ea3e39;
}

.el-button.isLight:active,
.el-button.isLight.is-active {
  background-color: rgba(255, 255, 255, 0.8);
  border-color: rgba(255, 255, 255, 0.8);
}

.el-button.isLight.is-disabled,
.el-button.isLight.is-disabled:active {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommonElForm.vue